if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        // Prefer cart drawer; cart-notification might exist without a JS class implementation
        const cartEl =
          document.querySelector("cart-drawer") ||
          document.querySelector("cart-notification");
        this.cart =
          cartEl &&
          typeof cartEl.getSectionsToRender === "function" &&
          typeof cartEl.renderContents === "function"
            ? cartEl
            : null;
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer") && this.submitButton) {
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        }

        this.hideErrors = this.dataset.hideErrors === "true";

        // Listen for variant changes to update button state
        this.variantSelects =
          this.closest(".product-details-quickview")?.querySelector(
            "fuzion-variant-picker, fuzion-variant-options",
          ) ||
          this.closest(".fusion-product-item")?.querySelector(
            "fuzion-variant-picker, fuzion-variant-options",
          ) ||
          this.querySelector("fuzion-variant-picker, fuzion-variant-options");

        if (this.variantSelects) {
          this.variantSelects.addEventListener(
            "change",
            this.onVariantChange.bind(this),
          );
        }
      }

      onVariantChange() {
        // Update button state when variant changes - add small delay to ensure variant ID is updated
        setTimeout(() => {
          if (this.variantSelects) {
            // Get the actual variant ID that will be submitted
            const variantId = this.form.querySelector('[name="id"]')?.value;

            // Get variant data and find the specific variant by ID
            // Use sync getter first, fallback to currentVariant
            const variantData = this.variantSelects.getVariantDataSync
              ? this.variantSelects.getVariantDataSync()
              : null;
            const selectedVariant =
              variantData && variantData.length > 0
                ? variantData.find((v) => v.id == variantId)
                : this.variantSelects.currentVariant;
            if (!this.variantSelects.currentVariant) return;

            if (selectedVariant && selectedVariant.available) {
              this.submitButton.removeAttribute("disabled");
              this.submitButton.removeAttribute("aria-disabled");
              // Update button text - handle both span wrapped and direct text
              const buttonSpan = this.submitButton.querySelector("span");
              const loadingSpinner = this.submitButton.querySelector(
                ".loading-overlay__spinner",
              );

              if (buttonSpan) {
                buttonSpan.textContent =
                  window.variantStrings?.addToCart || "Add to cart";
              } else {
                // Direct text in button, preserve loading spinner if exists
                this.submitButton.innerHTML =
                  (window.variantStrings?.addToCart || "Add to cart") +
                  (loadingSpinner ? loadingSpinner.outerHTML : "");
              }
            } else if (selectedVariant && !selectedVariant.available) {
              this.submitButton.setAttribute("disabled", "disabled");
              this.submitButton.setAttribute("aria-disabled", "true");
              // Update button text - handle both span wrapped and direct text
              const buttonSpan = this.submitButton.querySelector("span");
              const loadingSpinner = this.submitButton.querySelector(
                ".loading-overlay__spinner",
              );

              if (buttonSpan) {
                buttonSpan.textContent =
                  window.variantStrings?.soldOut || "Sold out";
              } else {
                // Direct text in button, preserve loading spinner if exists
                this.submitButton.innerHTML =
                  (window.variantStrings?.soldOut || "Sold out") +
                  (loadingSpinner ? loadingSpinner.outerHTML : "");
              }
            }
            // --- UPDATE STOCK BADGE ---
            const sectionEl =
              document.getElementById(
                `shopify-section-${this.dataset.sectionId}`,
              ) ||
              this.closest("section") ||
              this;
            const stockBadge = sectionEl.querySelector(".stock-badge");

            if (stockBadge) {
              if (selectedVariant.available) {
                stockBadge.textContent =
                  window.variantStrings?.inStock || "In stock";
                stockBadge.classList.remove("in_stock");
                stockBadge.classList.add("in_stock");
              } else {
                stockBadge.textContent =
                  window.variantStrings?.soldOut || "Sold out";
                stockBadge.classList.remove("in_stock");
                stockBadge.classList.add("in_stock");
              }
            }
          }
        }, 10);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        if (this.submitButton.disabled) return;

        const form = evt.target.closest("form");
        const selling_plan_error = form.querySelector(".selling_plan_error");
        if (!form) return; // ignore other forms

        // ---- Selling Plan Validation ----
        const sellingPlanInputs = form.querySelectorAll(
          'input[name="selling_plan"]',
        );
        if (sellingPlanInputs.length > 0) {
          const selectedPlan = form.querySelector(
            'input[name="selling_plan"]:checked',
          );
          const hasOneTimeOption = form.querySelector(
            'input[name="selling_plan"][value=""]',
          );

          // If product has plans and "one-time" is not allowed, enforce selection
          const productRequiresPlan =
            form.querySelector('input[name="selling_plan"][value=""]') === null;

          if (!selectedPlan) {
            if (selling_plan_error)
              selling_plan_error.textContent =
                window.variantStrings.sellingPlan;
            return false; // Prevent submission
          }
        }
        // ---- Subscription Price Validation ----
        try {
          const variantId = this.form.querySelector('[name="id"]')?.value;
          const selectedPlan = form.querySelector(
            'input[name="selling_plan"]:checked',
          );
          const variantSelects = this.variantSelects;

          if (
            variantSelects &&
            variantSelects.getVariantDataSync &&
            variantId &&
            selectedPlan
          ) {
            const variantData = variantSelects.getVariantDataSync();
            const selectedVariant =
              variantData && variantData.length > 0
                ? variantData.find((v) => v.id == variantId)
                : null;
            if (
              selectedVariant &&
              selectedVariant.selling_plan_allocations?.length
            ) {
              const selectedPlanId = parseInt(selectedPlan.value);
              const planAlloc = selectedVariant.selling_plan_allocations.find(
                (p) => p.selling_plan_id == selectedPlanId,
              );

              if (planAlloc) {
                const basePrice = parseInt(selectedVariant.price);
                const subscriptionPrice = parseInt(planAlloc.price);

                console.log(
                  "🧾 Base Price:",
                  basePrice,
                  "Subscription Price:",
                  subscriptionPrice,
                );

                if (subscriptionPrice > basePrice || subscriptionPrice <= 0) {
                  const errorMsg = window.variantStrings.checkSubscription;
                  if (selling_plan_error) {
                    selling_plan_error.textContent = errorMsg;
                    selling_plan_error.style.display = "block";
                  } else {
                    this.handleErrorMessage(errorMsg);
                  }

                  this.submitButton.classList.remove("loading");
                  this.submitButton.removeAttribute("aria-disabled");
                  this.querySelector(
                    ".loading-overlay__spinner",
                  )?.classList.add("hidden");
                  return false;
                }
              }
            }
          }
        } catch (err) {
          console.warn(window.variantStrings.subscriptionpricevalidation, err);
        }

        // Additional check: ensure we're not adding an out-of-stock variant
        const variantId = this.form.querySelector('[name="id"]')?.value;
        if (variantId) {
          const variantSelects = this.variantSelects;

          if (variantSelects) {
            // Get variant data and find the specific variant by ID
            // Use sync getter first, fallback to currentVariant
            const variantData = variantSelects.getVariantDataSync
              ? variantSelects.getVariantDataSync()
              : null;
            const selectedVariant =
              variantData && variantData.length > 0
                ? variantData.find((v) => v.id == variantId)
                : variantSelects.currentVariant;

            if (selectedVariant && !selectedVariant.available) {
              // Update button to show sold out state
              this.submitButton.setAttribute("disabled", "disabled");
              this.submitButton.setAttribute("aria-disabled", "true");
              const buttonSpan = this.submitButton.querySelector("span");
              const loadingSpinner = this.submitButton.querySelector(
                ".loading-overlay__spinner",
              );

              if (buttonSpan) {
                buttonSpan.textContent =
                  window.variantStrings?.soldOut || "Sold out";
              } else {
                // Direct text in button, preserve loading spinner if exists
                this.submitButton.innerHTML =
                  (window.variantStrings?.soldOut || "Sold out") +
                  (loadingSpinner ? loadingSpinner.outerHTML : "");
              }
              return;
            }
          }
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        // Form-level spinner (e.g. Dawn-style)
        const formSpinner = this.querySelector(".loading-overlay__spinner");
        if (formSpinner) formSpinner.classList.remove("hidden");
        // Button-level spinner (quickview / theme uses .custom-loading-spinner with display:none)
        const buttonSpinner = this.submitButton?.querySelector(
          ".loading-overlay__spinner, .custom-loading-spinner",
        );
        if (buttonSpinner) {
          buttonSpinner.style.display = "";
          buttonSpinner.classList.remove("hidden");
        }

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        const sellingPlanInput = this.form.querySelector(
          'input[name="selling_plan"]:checked',
        );

        if (this.cart && typeof this.cart.getSectionsToRender === "function") {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          if (typeof this.cart.setActiveElement === "function") {
            this.cart.setActiveElement(document.activeElement);
          }
        }

        if (sellingPlanInput && sellingPlanInput.value) {
          formData.append("selling_plan", sellingPlanInput.value);
        }

        config.body = formData;

        if (this.cart && typeof this.cart.setPendingAddToCart === "function") {
          this.cart.setPendingAddToCart(document.activeElement);
        } else if (this.cart) {
          this.cart.classList.add("is-add-to-cart-pending");
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              if (
                this.cart &&
                typeof this.cart.clearPendingAddToCart === "function"
              ) {
                this.cart.clearPendingAddToCart();
              }

              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              // If no cart-drawer element, use theme's cart drawer system
              const cartBtn = document.querySelector(".cart-btn");
              if (cartBtn) {
                if (typeof updateCartDrawer === "function") {
                  Promise.resolve(updateCartDrawer()).finally(() =>
                    cartBtn.click(),
                  );
                } else {
                  setTimeout(() => cartBtn.click(), 100);
                }
              } else {
                window.location = window.routes.cart_url;
              }
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              if (this.cart) {
                this.cart.renderContents(response);
              } else {
                // Fallback to theme's cart drawer system
                const cartBtn = document.querySelector(".cart-btn");
                if (cartBtn) {
                  if (typeof updateCartDrawer === "function") {
                    Promise.resolve(updateCartDrawer()).finally(() =>
                      cartBtn.click(),
                    );
                  } else {
                    setTimeout(() => cartBtn.click(), 100);
                  }
                }
              }
            }
          })
          .catch((e) => {
            if (
              this.cart &&
              typeof this.cart.clearPendingAddToCart === "function"
            ) {
              this.cart.clearPendingAddToCart();
            }
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            const formSpinner = this.querySelector(".loading-overlay__spinner");
            if (formSpinner) formSpinner.classList.add("hidden");
            const buttonSpinner = this.submitButton?.querySelector(
              ".loading-overlay__spinner, .custom-loading-spinner",
            );
            if (buttonSpinner) {
              buttonSpinner.style.display = "none";
              buttonSpinner.classList.add("hidden");
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
